import React from "react";
import { Routes, Route } from "react-router-dom";
import SearchResults from "./SearchResults";

const SearchModule = () => {
  return (
    <Routes>
      <Route index element={<SearchResults />} />
    </Routes>
  );
};

export default SearchModule;